<template>
<div class="full-block">
    <div class="container post_container">
        <div class="top" v-if="post">
            <div class="post_header">
                <h1>{{ post.title }}</h1>
                <div class="blog-category blog-category-line">
                    <div class="blog-category-item">
                            <p>{{ getFormatDate(post.published_date) }} | {{ post.categories ? post.categories.join(', ') : '' }}</p>
                        </div>
                    </div>
                <div class="post_img" :style="{'background-image': `url(${post.img})`}"></div>
            </div>
            <div class="post_content">
                <div v-html="post.content"></div>
            </div>
            <div class="post_rating">
                Rating: <span>{{ post.rating }}/5</span>
            </div>
            <div class="blog-tags">
                <div class="blog-tag-items">
                    <h2>Tags:</h2>
                    <ul>
                        <li v-for="item in post.tags" :key="item">
                            <a class="btn" href="#">{{ item }}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="social-icon blog-tags">
                <div class="social-icon-items blog-tag-items">
                    <h2>Share This Article</h2>
                    <ul>
                        <li><a class="btn" href="#"><font-awesome-icon :icon="['fab', 'facebook-square']" /></a></li>
                        <li><a class="btn" href="#"><font-awesome-icon :icon="['fab', 'twitter']" /></a></li>
                        <li><a class="btn" href="#"><font-awesome-icon :icon="['fab', 'linkedin']" /></a></li>
                        <li><a class="btn" href="#"><font-awesome-icon :icon="['fab', 'whatsapp']" /></a></li>
                        <li><a class="btn" href="#"><font-awesome-icon :icon="['fab', 'tumblr']" /></a></li>
                        <li><a class="btn" href="#"><font-awesome-icon :icon="['fab', 'pinterest']" /></a></li>
                        <li><a class="btn" href="#"><font-awesome-icon :icon="['fab', 'vk']" /></a></li>
                        <li><a class="btn" href="#"><font-awesome-icon :icon="['far', 'envelope']" /></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
export default {
    computed:{
        post(){
            return this.$store.getters['posts/getPost']
        }
    },
    methods:{
      getFormatDate : function (date) {
        return moment(date, 'YYYY-MM-DD').format('MMMM Do, YYYY');
      }
    },
    created(){
        let slug  = this.$route.params.slug;
        this.$store.dispatch('posts/getPost', slug);
        this.$store.dispatch('admin/postViews', slug);
    },
    destroyed(){
        this.$store.commit('posts/clearPost')
    }
}
</script>